import { useBitrate } from './use-bitrate'

export const BitrateManager = (): null => {
	useBitrate()

	return null
}
